export const NO_LETTERS_AND_LEADING_ZERO_REGEXP = /[^0-9]|^0{1}/g;
export const NOT_SPECIFIED_PROPERTY_VAL = '—';
export const RUNTIME_FIELD_MAX_LENGTH = 7;
export const LOAD_PLACEHOLDER = '#load#';
export const REQUIRED_RUNTIME_PARAMS = [
  'vah',
  'bcurveComp',
  'bcurveExpo',
  'bcurveSlope',
  'bcurveScale',
  'ptare',
];
export const RUNTIME_ERROR_CODES = {
  EMPTY: 'errorEmpty',
  NULL_PARAM: 'errorHasNull',
  EXCEED_MAX_CAPACITY: 'errorExceedMaxCapacity',
  LESS_THAN_MINIMUM: 'errorLessThanMinimum',
};
export const RUNTIME_LABEL_CODES = {
  PLEASE_ENTER_LOAD: 'pleaseEnterLoad',
  TOTAL_LOAD_EXCEEDS: 'totalLoadExceeds',
  ENTERED_LOAD_LESS_MINIMUM: 'enteredLoadLessMinimum',
  PLEASE_ENTER_LOAD_MAX_CAPACITY: 'pleaseEnterLoadMaxCapacity',
};
export const RUNTIME_ERROR_CODES_TO_LABELS = {
  LOAD: {
    [RUNTIME_ERROR_CODES.EMPTY]: RUNTIME_LABEL_CODES.PLEASE_ENTER_LOAD,
    [RUNTIME_ERROR_CODES.EXCEED_MAX_CAPACITY]: RUNTIME_LABEL_CODES.TOTAL_LOAD_EXCEEDS,
    [RUNTIME_ERROR_CODES.LESS_THAN_MINIMUM]: RUNTIME_LABEL_CODES.ENTERED_LOAD_LESS_MINIMUM,
  },
  MAX_CAPACITY: {
    [RUNTIME_ERROR_CODES.EMPTY]: RUNTIME_LABEL_CODES.PLEASE_ENTER_LOAD_MAX_CAPACITY,
  },
};
export const RUNTIME_FIELDS = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};
